/**
 * Next step types
 * @readonly
 * @enum
 */
export const NextStep = {
  CourseMaterialNextStep: 'org.coursera.ondemand.guided.nextstep.CourseMaterialNextStep',
  SwitchSessionNextStep: 'org.coursera.ondemand.guided.nextstep.SwitchSessionNextStep',
  CourseCompletedNextStep: 'org.coursera.ondemand.guided.nextstep.CourseCompletedNextStep',
};

export type SkippableNextStep =
  | 'CourseCompletedNextStep'
  | 'CourseScheduleAdjustmentNextStep'
  | 'NoActiveSessionNextStep'
  | 'SessionEndedNextStep'
  | 'MultipleDeadlinesNextStep'
  | 'NotEnoughPeerReviewsNextStep'
  | 'CourseMaterialNextStep'
  | 'NoEnrollableSessionsNextStep';

const allSkippableNextSteps: SkippableNextStep[] = [
  'CourseCompletedNextStep',
  'CourseScheduleAdjustmentNextStep',
  'NoActiveSessionNextStep',
  'SessionEndedNextStep',
  'MultipleDeadlinesNextStep',
  'NotEnoughPeerReviewsNextStep',
  'CourseMaterialNextStep',
  'NoEnrollableSessionsNextStep',
];

export function getAllSkippableNextStepsExcept(excluding: Set<SkippableNextStep>): SkippableNextStep[] {
  return allSkippableNextSteps.filter((step) => !excluding.has(step));
}
